let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dO3ef")).then(() => parcelRequire('6ck4v'));